// @flow
import type { Location } from 'react-router-dom';

const possibleQueryParams = [
  'category',
  'product_link',
  'searchedQuery',
  'campaign_id',
  'campaign_status',
  'inviteOpen',
];

export type QueryParams = {|
  category: string | null,
  product_link: string | null,
  searchedQuery: string | null,
  campaign_id: string | null,
|};

type PossibleQueryParams = {|
  ...QueryParams,
  [string]: string | null,
|};

const emptyQueryParams: QueryParams = {
  category: null,
  product_link: null,
  searchedQuery: null,
  campaign_id: null,
};

export function getQueryParams(search: string): QueryParams {
  const urlSearchParams = new URLSearchParams(search);
  return possibleQueryParams.reduce(
    (queryParams, param) => {
      // eslint-disable-next-line no-param-reassign
      queryParams[param] = urlSearchParams.get(param);
      return queryParams;
    },
    { ...emptyQueryParams }
  );
}

export function getPathname(): string {
  return window.location.pathname;
}

export function getQueryParam(queryParamName: string) {
  return new URL(window.location.href).searchParams.get(queryParamName);
}

/**
 * Higher order function used in React Router Link to attribute
 * @param  {string} newQueryParams query params that should change
 * @param {boolean} state I don't know what this is
 * @returns {Shape<QueryParams>} a function that can be passed to React Router Link to attribute
 */
export function updateLocationSearch(
  newQueryParams: $Shape<QueryParams>,
  state: {| accordionInGrid: boolean |} = { accordionInGrid: false }
) {
  return function updateLocation(location: Location) {
    const previousQueryParams = getQueryParams(location.search);
    const nextQueryParams = {
      ...previousQueryParams,
      ...newQueryParams,
    };
    const search = buildLocationSearch(nextQueryParams);
    return { ...location, search, state };
  };
}

export function buildLocationSearch(
  nextQueryParams: $Shape<PossibleQueryParams>
) {
  let locationSearch = '?';
  // eslint-disable-next-line guard-for-in
  for (const queryParam in nextQueryParams) {
    const queryParamValue = nextQueryParams[queryParam];
    if (queryParamValue !== null) {
      locationSearch += `${queryParam}=${queryParamValue}&`;
    }
  }
  return locationSearch.slice(0, locationSearch.length - 1);
}

export function removeQueryParam(queryParamToRemove: QueryParams) {
  const currentQueryParams = getQueryParams(window.location.search);
  let locationSearch = '?';
  for (const queryParam in currentQueryParams) {
    if (queryParam === queryParamToRemove) {
      // eslint-disable-next-line no-continue
      continue;
    }
    const queryParamValue = currentQueryParams[queryParam];
    if (queryParamValue !== null) {
      locationSearch += `${queryParam}=${queryParamValue}&`;
    }
  }
  return locationSearch.slice(0, locationSearch.length - 1);
}
